import { Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

export const InitialPreview = styled.div`
  align-items: center;
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  min-height: 682px;
  width: 500px;

  ${Typography.S.Typography} {
    margin-top: 16px;
  }
`;

export const MessageCardWrapper = styled.div`
  min-height: 682px;
  width: 500px;

  .card-header {
    display: flex;
    justify-content: space-between;
  }
  .card-wrapper {
    height: 100%;
    padding: 24px;
  }
`;

export const RecipientDetailButton = styled.button`
  align-items: center;
  background: var(--color-gray-25);
  border: none;
  border-radius: var(--size-border-radius-md);
  color: var(--color-accent-primary-default);
  cursor: pointer;
  display: flex;
  font-size: 12px;
  font-weight: 700;
  padding: 8px;
`;

export const RecipientName = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: row;
  max-width: 150px;
  overflow: overlay;
`;

export const TableContainer = styled.div`
  flex: 1;
`;

export const Wrapper = styled.div`
  display: flex;
  gap: 24px;
`;
